// Bottle Switcher Functionality
document.addEventListener('DOMContentLoaded', function() {
  // Content for different bottle types
  const bottleContent = {
    standard: {
      // bundle-includes content
      image: "https://cdn.shopify.com/s/files/1/0512/4289/3477/files/IMG-2943.jpg?v=1729057857",
      title: "1 JuiceBox™ drinkfles",
      originalPrice: "9,90€",
      discountedPrice: "0,00€",
      headlineText: "Vandaag GRATIS in de set:",
      listItemText: "<span>✓</span> <strong>1x&nbsp;</strong> Drinkfles",
      
      // accordion content
      accordionImage: "https://cdn.shopify.com/s/files/1/0512/4289/3477/files/IMG-2943.jpg?v=1729057857",
      accordionTitle: "Drinkfles",
      accordionBadge: "Gratis"
    },
    premium: {
      // bundle-includes content
      image: "https://cdn.shopify.com/s/files/1/0512/4289/3477/files/glass_bottle_no_badge.webp?v=1740401399",
      title: "1 JuiceBox™ glazen drinkfles 1 L",
      originalPrice: "24,90€",
      discountedPrice: "9,90€",
      headlineText: "Jouw set-voordelen:",
      listItemText: "<span>✓</span> <strong>1x&nbsp;</strong> Glazen drinkfles 1 L",
      
      // accordion content
      accordionImage: "https://cdn.shopify.com/s/files/1/0512/4289/3477/files/glass_bottle_no_badge.webp?v=1740401399",
      accordionTitle: "Glazen drinkfles 1 L",
      accordionBadge: "bespaar € 15,00"
    }
  };
  
  // Function to update all bottle-related content
  function updateBottleContent(bottleType) {
    const content = bottleContent[bottleType];
    
    // Update all elements by ID
    const elements = {
      // bundle-includes elements
      image: document.getElementById('bottle-image-display'),
      heading: document.getElementById('bottle-heading'),
      title: document.getElementById('bottle-title'),
      originalPrice: document.getElementById('bottle-original-price'),
      discountedPrice: document.getElementById('bottle-discounted-price'),
      listItem: document.getElementById('bottle-list-item'),
      
      // accordion elements
      accordionImage: document.getElementById('accordion-bottle-image'),
      accordionTitle: document.getElementById('accordion-bottle-title'),
      accordionBadge: document.getElementById('accordion-bottle-badge')
    };
    
    // Set content for each element if it exists
    if (elements.image) elements.image.src = content.image;
    if (elements.heading) elements.heading.textContent = content.headlineText;
    if (elements.title) elements.title.textContent = content.title;
    if (elements.originalPrice) elements.originalPrice.textContent = content.originalPrice;
    if (elements.discountedPrice) elements.discountedPrice.textContent = content.discountedPrice;
    if (elements.listItem) elements.listItem.innerHTML = content.listItemText;
    
    // Set accordion content
    if (elements.accordionImage) elements.accordionImage.src = content.accordionImage;
    if (elements.accordionTitle) elements.accordionTitle.textContent = content.accordionTitle;
    if (elements.accordionBadge) elements.accordionBadge.textContent = content.accordionBadge;
  }
  
  // Observer to watch for changes to the bottle selection
  function initBottleSwitcher() {
    const bottleCards = document.querySelectorAll('.JB-bottle-card');
    if (bottleCards.length === 0) return false;
    
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'class') {
          const targetElement = mutation.target;
          if (targetElement.classList.contains('active')) {
            const bottleTypeValue = targetElement.querySelector('input[type="text"]').value;
            updateBottleContent(bottleTypeValue === 'premium-bottle' ? 'premium' : 'standard');
          }
        }
      });
    });
    
    // Start observing the bottle selection cards
    bottleCards.forEach(card => {
      observer.observe(card, { attributes: true });
    });
    
    // Set initial content based on which card is active
    bottleCards.forEach(card => {
      if (card.classList.contains('active')) {
        const bottleTypeValue = card.querySelector('input[type="text"]').value;
        updateBottleContent(bottleTypeValue === 'premium-bottle' ? 'premium' : 'standard');
      }
    });
    
    return true;
  }
  
  // Try to initialize, retry with a delay if elements aren't available yet
  if (!initBottleSwitcher()) {
    const checkInterval = setInterval(function() {
      if (initBottleSwitcher()) {
        clearInterval(checkInterval);
      }
    }, 500);
  }
});

// End Bottle Switcher Functionality